import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';
import NotificationWizardModal from './NotificationWizardModal';
export default class GuidesModal extends Modal {
  onsubmit(e) {
    if (e) e.preventDefault();
  }
  className() {
    return 'GuidesModal Modal--medium';
  }
  title() {
    return app.translator.trans('nagusi-tutorials.forum.guides_modal.title') !== 'nagusi-tutorials.forum.guides_modal.title' ? app.translator.trans('nagusi-tutorials.forum.guides_modal.title') : 'Guías y Asistentes del Foro';
  }
  openNotificationWizard() {
    app.modal.show(NotificationWizardModal, {
      fromGuides: true
    });
  }
  goToSection(slug) {
    app.modal.close();
    m.route.set(app.route('nagusi.tutorials.ayuda.section', {
      slug
    }));
  }
  goToHelpIndex() {
    app.modal.close();
    m.route.set(app.route('nagusi.tutorials.ayuda'));
  }
  content() {
    return m("div", {
      className: "Modal-body GuidesModal-body"
    }, m("div", {
      className: "GuidesModal-intro"
    }, m("div", {
      className: "GuidesModal-introIcon"
    }, m("i", {
      className: "fas fa-graduation-cap"
    })), m("div", {
      className: "GuidesModal-introText"
    }, m("h3", null, app.translator.trans('nagusi-tutorials.forum.guides_modal.intro_title') || 'Aprende y personaliza tu foro por capítulos'), m("p", null, app.translator.trans('nagusi-tutorials.forum.guides_modal.subtitle') || 'Selecciona una guía o asistente para configurar Aurrera Athletic y sacarle todo el provecho:'))), m("div", {
      className: "GuidesModal-chaptersList"
    }, m("div", {
      className: "GuidesModal-chapterCard GuidesModal-chapterCard--wizard",
      onclick: () => this.openNotificationWizard()
    }, m("div", {
      className: "GuidesModal-chapterHeader"
    }, m("span", {
      className: "GuidesModal-chapterNum"
    }, app.translator.trans('nagusi-tutorials.forum.guides_modal.chapter_label', {
      number: 1
    }) || 'Capítulo 1'), m("span", {
      className: "GuidesModal-badge GuidesModal-badge--wizard"
    }, m("i", {
      className: "fas fa-magic"
    }), " ", app.translator.trans('nagusi-tutorials.forum.guides_modal.chapters.notifications.badge') || 'Configurador Interactivo')), m("div", {
      className: "GuidesModal-chapterBody"
    }, m("div", {
      className: "GuidesModal-chapterIcon GuidesModal-chapterIcon--bell"
    }, m("i", {
      className: "fas fa-bell"
    })), m("div", {
      className: "GuidesModal-chapterInfo"
    }, m("h4", null, app.translator.trans('nagusi-tutorials.forum.guides_modal.chapters.notifications.title') || 'Configurar Notificaciones y Avisos'), m("p", null, app.translator.trans('nagusi-tutorials.forum.guides_modal.chapters.notifications.description') || 'Te ayudamos a elegir qué avisos recibir (goles, menciones, porras, mensajes privados) y a activar el permiso de tu móvil o navegador en 30 segundos.'))), m("div", {
      className: "GuidesModal-chapterAction"
    }, m(Button, {
      className: "Button Button--primary GuidesModal-btnAction",
      icon: "fas fa-sliders-h"
    }, app.translator.trans('nagusi-tutorials.forum.guides_modal.open_wizard') || 'Abrir Asistente'))), m("div", {
      className: "GuidesModal-chapterCard",
      onclick: () => this.goToSection('como-instalar-app-movil')
    }, m("div", {
      className: "GuidesModal-chapterHeader"
    }, m("span", {
      className: "GuidesModal-chapterNum"
    }, app.translator.trans('nagusi-tutorials.forum.guides_modal.chapter_label', {
      number: 2
    }) || 'Capítulo 2'), m("span", {
      className: "GuidesModal-badge GuidesModal-badge--guide"
    }, m("i", {
      className: "fas fa-book-open"
    }), " ", app.translator.trans('nagusi-tutorials.forum.guides_modal.chapters.pwa.badge') || 'Guía paso a paso')), m("div", {
      className: "GuidesModal-chapterBody"
    }, m("div", {
      className: "GuidesModal-chapterIcon GuidesModal-chapterIcon--mobile"
    }, m("i", {
      className: "fas fa-mobile-alt"
    })), m("div", {
      className: "GuidesModal-chapterInfo"
    }, m("h4", null, app.translator.trans('nagusi-tutorials.forum.guides_modal.chapters.pwa.title') || 'Instalar la App en el móvil (PWA)'), m("p", null, app.translator.trans('nagusi-tutorials.forum.guides_modal.chapters.pwa.description') || 'Ten Aurrera Athletic en tu pantalla de inicio como una aplicación con acceso instantáneo y notificaciones.'))), m("div", {
      className: "GuidesModal-chapterAction"
    }, m(Button, {
      className: "Button Button--secondary GuidesModal-btnAction",
      icon: "fas fa-chevron-right"
    }, app.translator.trans('nagusi-tutorials.forum.guides_modal.read_guide') || 'Ver Guía'))), m("div", {
      className: "GuidesModal-chapterCard",
      onclick: () => this.goToSection('guia-interfaz-ordenador')
    }, m("div", {
      className: "GuidesModal-chapterHeader"
    }, m("span", {
      className: "GuidesModal-chapterNum"
    }, app.translator.trans('nagusi-tutorials.forum.guides_modal.chapter_label', {
      number: 3
    }) || 'Capítulo 3'), m("span", {
      className: "GuidesModal-badge GuidesModal-badge--guide"
    }, m("i", {
      className: "fas fa-desktop"
    }), " ", app.translator.trans('nagusi-tutorials.forum.guides_modal.chapters.interface.badge') || 'Visual')), m("div", {
      className: "GuidesModal-chapterBody"
    }, m("div", {
      className: "GuidesModal-chapterIcon GuidesModal-chapterIcon--desktop"
    }, m("i", {
      className: "fas fa-columns"
    })), m("div", {
      className: "GuidesModal-chapterInfo"
    }, m("h4", null, app.translator.trans('nagusi-tutorials.forum.guides_modal.chapters.interface.title') || 'Conoce la Interfaz y los Menús'), m("p", null, app.translator.trans('nagusi-tutorials.forum.guides_modal.chapters.interface.description') || 'Aprende para qué sirve cada botón, la barra lateral, el buscador rápido y las opciones de lectura.'))), m("div", {
      className: "GuidesModal-chapterAction"
    }, m(Button, {
      className: "Button Button--secondary GuidesModal-btnAction",
      icon: "fas fa-chevron-right"
    }, app.translator.trans('nagusi-tutorials.forum.guides_modal.read_guide') || 'Ver Guía'))), m("div", {
      className: "GuidesModal-chapterCard",
      onclick: () => this.goToSection('juegos-concursos-y-valoraciones')
    }, m("div", {
      className: "GuidesModal-chapterHeader"
    }, m("span", {
      className: "GuidesModal-chapterNum"
    }, app.translator.trans('nagusi-tutorials.forum.guides_modal.chapter_label', {
      number: 4
    }) || 'Capítulo 4'), m("span", {
      className: "GuidesModal-badge GuidesModal-badge--games"
    }, m("i", {
      className: "fas fa-trophy"
    }), " ", app.translator.trans('nagusi-tutorials.forum.guides_modal.chapters.games.badge') || 'Juegos y Porras')), m("div", {
      className: "GuidesModal-chapterBody"
    }, m("div", {
      className: "GuidesModal-chapterIcon GuidesModal-chapterIcon--games"
    }, m("i", {
      className: "fas fa-gamepad"
    })), m("div", {
      className: "GuidesModal-chapterInfo"
    }, m("h4", null, app.translator.trans('nagusi-tutorials.forum.guides_modal.chapters.games.title') || '11 Aldeanos, La Bolilla y Trofeos'), m("p", null, app.translator.trans('nagusi-tutorials.forum.guides_modal.chapters.games.description') || 'Cómo pronosticar la alineación antes del partido, acertar resultados en la porra y ganar la txapela.'))), m("div", {
      className: "GuidesModal-chapterAction"
    }, m(Button, {
      className: "Button Button--secondary GuidesModal-btnAction",
      icon: "fas fa-chevron-right"
    }, app.translator.trans('nagusi-tutorials.forum.guides_modal.read_guide') || 'Ver Guía'))), m("div", {
      className: "GuidesModal-chapterCard",
      onclick: () => this.goToSection('guia-editor-y-subir-imagenes')
    }, m("div", {
      className: "GuidesModal-chapterHeader"
    }, m("span", {
      className: "GuidesModal-chapterNum"
    }, app.translator.trans('nagusi-tutorials.forum.guides_modal.chapter_label', {
      number: 5
    }) || 'Capítulo 5'), m("span", {
      className: "GuidesModal-badge GuidesModal-badge--stickers"
    }, m("i", {
      className: "fas fa-smile"
    }), " ", app.translator.trans('nagusi-tutorials.forum.guides_modal.chapters.editor.badge') || 'Stickers y Multimedia')), m("div", {
      className: "GuidesModal-chapterBody"
    }, m("div", {
      className: "GuidesModal-chapterIcon GuidesModal-chapterIcon--stickers"
    }, m("i", {
      className: "fas fa-icons"
    })), m("div", {
      className: "GuidesModal-chapterInfo"
    }, m("h4", null, app.translator.trans('nagusi-tutorials.forum.guides_modal.chapters.editor.title') || 'Stickers del León y Editor'), m("p", null, app.translator.trans('nagusi-tutorials.forum.guides_modal.chapters.editor.description') || 'Descubre todos los emojis propios rojiblancos, cómo subir fotos y dar formato a tus posts.'))), m("div", {
      className: "GuidesModal-chapterAction"
    }, m(Button, {
      className: "Button Button--secondary GuidesModal-btnAction",
      icon: "fas fa-chevron-right"
    }, app.translator.trans('nagusi-tutorials.forum.guides_modal.read_guide') || 'Ver Guía')))), m("div", {
      className: "GuidesModal-footer"
    }, m("button", {
      type: "button",
      className: "Button Button--link GuidesModal-btnAllHelp",
      onclick: e => {
        e.preventDefault();
        this.goToHelpIndex();
      }
    }, m("i", {
      className: "fas fa-book"
    }), ' ', app.translator.trans('nagusi-tutorials.forum.guides_modal.full_help_link') || 'Ver el Centro de Ayuda completo con buscador')));
  }
}
_defineProperty(GuidesModal, "isDismissibleViaBackdropClick", false);
flarum.reg.add('nagusi-match-ratings', 'forum/tutorials/GuidesModal', GuidesModal);